import React from "react";

export default function Background() {
    return (
        <>
            <div className={"d-flex align-items-center py-2 px-2 px-md-3"}>
                <div className={"flex-shrink-0"}>
                    <img src={"/logo.svg"} alt="Background" className={"d-none d-md-block"} style={{width: "200px", height: "auto"}} />
                    <img src={"/logo.svg"} alt="Background" className={"d-md-none"} style={{width: "110px", height: "auto"}} />
                </div>
                <div className={"flex-fill px-2"}>
                    <h1 className={"text-center m-0"} style={{fontSize: "clamp(1rem, 3.5vw, 2rem)"}}>Collection Platform</h1>
                </div>
                <div className={"flex-shrink-0 d-none d-md-block"} style={{width: "200px"}}></div>
            </div>
        </>
    );
};
